module.exports = __webpack_public_path__ + "img/banner1.feb6ce29.jpg";